import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingScreen } from '@/components/feedback/loading-screen';
import { retry } from '@/utils/helpers/common';

const PrivacyPolicyPage = lazy(
  () =>
    retry(() => import('@/pages/legal/privacy-policy')) as Promise<
      typeof import('@/pages/legal/privacy-policy')
    >
);

/**
 * Legal routes (no authentication required)
 */
export const legalRoutes = [
  {
    path: 'legal',
    element: (
      <Suspense fallback={<LoadingScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        path: 'privacy-policy',
        element: <PrivacyPolicyPage />,
      },
    ],
  },
];
